export const environment = {
  production: true,
  appVersion: 'v726demo1',
  USERDATA_KEY: 'authf649fc9a5f55',

  apiUrl: 'https://api.statendrivingschool.com/api',
  patchUrl: 'https://api.statendrivingschool.com',
  googleClientId: '42401195913-gdcb57ct4ahtc60jar21991kgf0tfrtl.apps.googleusercontent.com',


  // apiUrl: 'https://localhost:7285/api',
  // patchUrl: 'https://localhost:7285',
};

